<template>
  <div class="tile-colors">

    <div class="intro">Please select your tile colors.</div>

    name: {{pattern.name}}<br>
    svg: {{pattern.svg}}<br>
    polygonsCount: {{polygonsCount}}<br>

    <div class="row">
        <div class="col-sm-6">
            <div class="tile">
                <object type="image/svg+xml" :data="pattern.svg" class="pattern" @load="svgInit($event)" ref="svgObject"></object>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="colors">
                <div class="row">
                    <div class="col-sm-3" v-for="(object, index) in pallete" :key="index" :style="{borderColor: object.color}" >
                        <span class="color" :style="{backgroundColor: object.color}" :class="{active: object.color === currentColor.color}" @click="colorSelect(object, index)">{{object.name}}</span>
                    </div>
                </div>
                <ul>

                </ul>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'TileColors',
        data(){

            return {
                currentColor: {},
                svg: null
            }

        },
        computed: {
            pallete(){
                return this.$store.state.pallete;
            },
            pattern() {
                return this.$store.state.pattern;
            },
            
            colors() {
                return this.$store.state.colors;
            },
            polygonsCount() {
            var str = this.$store.state.pattern.svg;   
            var last = str.split('in').pop().split('out')[0];           
            return last;
            },

            image(){
                return [this.svg, this.colors];
            }
        },
        watch: {
            image() {
                if(this.svg){
                    let vectors = this.svg.children;

                    for(let i = 0; i < vectors.length; i++){
                        let vector = vectors[i];

                        if(this.colors[vector.id]){
                            vector.setAttribute('fill', this.colors[vector.id].color);
                            console.log('object'+Object.keys(this.colors).length);
                            console.log('svg-children'+this.svg.children.length);
                            console.log('polygonsCount'+this.polygonsCount);
                        }else{
                            vector.setAttribute('fill', '#ffffff');
                            console.log('object'+Object.keys(this.colors).length);
                            console.log('svg-children'+this.svg.children.length);
                            console.log('polygonsCount'+this.polygonsCount);
                        }
                    }

                    let xml = new XMLSerializer().serializeToString(this.svg);

                    this.$store.commit('setColorImage', "data:image/svg+xml;base64," + btoa(xml));

                    //if(Object.keys(this.colors).length == this.svg.children.length){
                    if(Object.keys(this.colors).length == this.polygonsCount){    
                        this.$emit('ready', true);
                    }else{
                        this.$emit('ready', false);
                    }
                }
            }
        },
        methods: {
            colorSelect(color, index){

                this.currentColor = Object.assign({}, color, {index: index});

            },
            colorChange(event){

                let vm = this;

                if(!this.currentColor.name){

                    alert('Please select a color first!');

                }else{

                    let color = Object.assign({}, this.currentColor , {
                        vector: event.target.id,
                        x: event.x/vm.$refs.svgObject.offsetWidth,
                        y: event.y/vm.$refs.svgObject.offsetHeight
                    })

                    vm.$store.dispatch('addColor' , color);

                }
            },
            svgInit(event) {
                let vm = this;

                let svgObject = event.currentTarget,
                    svgDoc = null;

                try {
                    svgDoc = svgObject.contentDocument;
                }
                catch(e) {
                    svgDoc = svgObject.getSVGDocument();
                }

                let svgElements = svgDoc.getElementsByTagName('svg');

                if(svgElements.length){

                    vm.svg = svgElements[0];
                    vm.svg.addEventListener("click", vm.colorChange, false);
                }

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .intro{
        text-align: center;
        padding-bottom: 15px;
    }

    .tile{
        &:hover{
            cursor: pointer;
        }

        .pattern{
            width: 100%;
        }
    }

    .colors > .row{
        margin-left: -5px;
        margin-right: -5px;

        & > div{
            padding-left: 5px;
            padding-right: 5px;
        }
    }

    .color{
        padding: 5px 15px;
        display: block;
        font-size: 14px;
        color: #fff;
        transition: all 0.2s ease-in-out;

        &:hover{
            cursor: pointer;
            /*-ms-transform: scale(1.1); !* IE 9 *!*/
            /*-webkit-transform: scale(1.1); !* Safari *!*/
            /*transform: scale(1.1);*/
        }

        &.active{
            /*border-color: #000 !important;*/

            z-index: 1;
            position: relative;

            -ms-transform: scale(1.2); /* IE 9 */
            -webkit-transform: scale(1.2); /* Safari */
            transform: scale(1.2);
        }
    }
</style>
